import React from "react";
import styled from "@emotion/styled";

import { Card, CardHeader } from "../Card/Card";
import { UnderlinedButtonStyle } from "./shared";
import type { ContactType } from "./types";
import { CONTACT_TYPES_TEXT, TEST_ID_PREFIX } from "./constants";

const AddNewContact = ({ contactType, onAdd }: AddNewContactProps) => (
  <Card>
    <CardHeaderStyled
      title={`Add New ${CONTACT_TYPES_TEXT[contactType]}`}
      rightContent={
        <UnderlinedButtonStyle
          size="xs"
          color="tertiary"
          onClick={(e) => {
            e.stopPropagation();
            onAdd();
          }}
          data-testid={`${TEST_ID_PREFIX[contactType]}-select-add`}
        >
          Add
        </UnderlinedButtonStyle>
      }
    />
  </Card>
);
interface AddNewContactProps {
  contactType: ContactType;
  onAdd: () => void;
}

const CardHeaderStyled = styled(CardHeader)`
  border-bottom: unset;
`;

export type { AddNewContactProps };
export { AddNewContact };
